import React from 'react'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'
import { Create } from 'react-admin'
import ProductSectionForm from 'ui-shared/Forms/ProductSectionForm'

const RentSectionCreate: React.FC = () => {
  return (
    <SectionWrapper title={'resources.rentsections.createSection'}>
      <Create>
        <ProductSectionForm entity="rents" />
      </Create>
    </SectionWrapper>
  )
}

export default RentSectionCreate
